import React, { useEffect, useState } from 'react';
import './ContentfulWebinarPage.css';
import Grid from '@mui/material/Grid';
import { useParams } from 'react-router-dom';
import { createClient } from 'contentful';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'; // Import the library
import CompMarquee from '../Components/CompMarquee';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ctaImage from '../Assets/Images/uxi-webinar-CTA.png';

const ContentfulWebinarPage = () => {
  const { slug } = useParams(); // Get the slug from the route
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const client = createClient({
      space: 'g12j3qznit83',
      accessToken: 'vbq3bte2RRUyj8_Mm1UGzxpAXhTn_dvVyUFFrQbUryM',
    });

    client.getEntries({
      content_type: 'webinar', // Replace with your Contentful content type ID
      'fields.slug': slug, // Filter by slug
    })
      .then((response) => {
        console.log('Contentful data:', response.items[0]?.fields);
        setContent(response.items[0]); // Assuming one entry per slug
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error fetching data from Contentful:', error);
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return <div>Loading content...</div>;
  }

  if (!content) {
    return <div>No content found for this slug.</div>;
  }

  return (
    <div>
      <CompMarquee title={content.fields.header} subTitle={content.fields.subheading1} />
      <Paper elevation={3} style={{ padding: '20px', maxWidth: '80%', margin: '20px auto 0', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
        <div style={{ padding: '8px', textAlign: 'center', color: '#333', fontFamily: 'Roboto', fontSize: '1.1rem' }}>
          {/*{content.fields.introductionText}<br />*/}
          <h2 style={{ margin: '0'}}>{content.fields.webinarDateAndTime}</h2>
        </div>
      </Paper>
      <Paper elevation={3} style={{ padding: '20px', maxWidth: '80%', margin: '20px auto 0', backgroundColor: 'rgba(255, 255, 255, 0.9)' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={8}>
          <Grid container spacing={2} marginBottom={2}>
            <Grid item xs={12} md={4}>
              <img src={content.fields.bullet1Image ? `https:${content.fields.bullet1Image.fields.file.url}` : 'http://placehold.co/400x200'} alt="Webinar Feature" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={12} md={8}>
              <h3 style={{ margin: '0 0 10px 0' }}>{content.fields.bullet1Heading}</h3>
              {content.fields.bullet1text}
            </Grid>
          </Grid>
          <Grid container spacing={2} marginBottom={2}>
            <Grid item xs={12} md={4}>
              <img src={content.fields.bullet2Image ? `https:${content.fields.bullet2Image.fields.file.url}` : 'http://placehold.co/400x200'} alt="Webinar Feature" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={12} md={8}>
              <h3 style={{ margin: '0 0 10px 0' }}>{content.fields.bullet2Heading}</h3>
              {content.fields.bullet2Text}
            </Grid>
          </Grid>
          <Grid container spacing={2} marginBottom={2}>
            <Grid item xs={12} md={4}>
              <img src={content.fields.bullet3Image ? `https:${content.fields.bullet3Image.fields.file.url}` : 'http://placehold.co/400x200'} alt="Webinar Feature" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={12} md={8}>
              <h3 style={{ margin: '0 0 10px 0' }}>{content.fields.bullet3Heading}</h3>
              {content.fields.bullet3Text}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={4}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, justifyContent: 'flex-start', alignItems: 'center' }}>
            {content.fields.ctaImage ? (
              <img 
                src={`https:${content.fields.ctaImage.fields.file.url}`}
                alt="Webinar Call to Action" 
                style={{ width: '100%', borderRadius: '8px' }} 
              />
            ) : (
              <img 
                src={ctaImage} 
                alt="Webinar Call to Action" 
                style={{ width: '100%', borderRadius: '8px' }} 
              />
            )}
            <Typography 
              variant="body1" 
              sx={{ textAlign: 'center', color: '#333' }}
            >
              {content.fields.ctaText}
            </Typography>
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              href={content.fields.callToActionLink}
              sx={{ 
                padding: '16px 32px',
                fontSize: '1.1rem',
                fontWeight: 'bold',
                width: '100%',
                backgroundColor: '#1976d2',
                '&:hover': {
                  backgroundColor: '#1565c0',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 8px 16px rgba(0,0,0,0.2)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              {content.fields.callToActionText || 'Join Webinar'}
            </Button>
          </Box>
        </Grid>
      </Grid>
      </Paper>
    </div>
  );
};

export default ContentfulWebinarPage;
